/*
	Thin fetch wrapper. In dev the vue-cli proxy forwards /oauth and /api to the
	local ddev API (same origin, no CORS). In prod the SPA lives on
	auth.geekgroup.app and talks to api.geekgroup.app directly — the API sets
	permissive CORS (origin + credentials), so the shared cookie rides along.

	The geekgroup login endpoints currently live under /api/tally/session/* —
	they're generic geekgroup auth (username+password / geekmail code) that the
	IdP reuses; nothing Tally-specific. They can move to /api/session/* later.
*/

var API = /(?:^|\.)geekgroup\.app$/.test(window.location.hostname) ? 'https://api.geekgroup.app' : ''

function request(method, path, body, token) {

	var headers = { 'content-type': 'application/json', 'ngrok-skip-browser-warning': 'true' }

	if (token) headers['Authorization'] = token

	return fetch(API + path, {
		method: method,
		headers: headers,
		credentials: 'include',
		body: body ? JSON.stringify(body) : undefined
	}).then(function(res) {

		return res.json().catch(function() { return {} })

	}).catch(function() {

		return { error: 'network' }

	})

}

function query(params) {

	return Object.keys(params)
		.filter(function(k) { return params[k] !== undefined && params[k] !== null && params[k] !== '' })
		.map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) })
		.join('&')

}

export default {

	// public client metadata for the consent screen
	client: function(q) {

		return request('GET', '/oauth/client?' + query({ client_id: q.client_id, redirect_uri: q.redirect_uri, scope: q.scope }))

	},

	// resolve the current geekgroup token to a profile.
	// NB: the /api/tally/* endpoints follow FuelPHP's REST convention and need
	// the .json extension to return JSON (the default is XML); the /oauth/*
	// endpoints force JSON server-side, so they don't.
	recognise: function(token) {

		return request('POST', '/api/tally/session/recognise.json', { geekgroup: token })

	},

	login: function(username, password) {

		return request('POST', '/api/tally/session/login.json', { username: username, password: password })

	},

	sendCode: function(username) {

		return request('POST', '/api/tally/session/code/send.json', { username: username })

	},

	verifyCode: function(username, code) {

		return request('POST', '/api/tally/session/code/login.json', { username: username, code: code })

	},

	// mint the authorization code (returns { redirect })
	grant: function(params, token) {

		return request('POST', '/oauth/grant', params, token)

	}

}
